<template>
    <div class="bannerBox">
        <div class="bannerBg"></div>
        <div class="leftLogo flex_l">
            <img :src="user.logo" />
            <span>{{user.name}}</span>
        </div>
        <p class="topTitle">{{title}}</p>
    </div>

</template>

<script>
    import {ref,getCurrentInstance,onMounted} from 'vue'

    export default {
        props: {
            title: String,
        },
        setup() {
            const user = ref({
                name:'',
                logo:''
            })

            let json =  localStorage.getItem('collegeDetail')
            if(json){
              let  collegeDetail = JSON.parse(json)
                user.value.name= collegeDetail.name;
                user.value.logo =collegeDetail.logo
            }
            // user.value.name = "天基大学";
            // user.value.logo = "https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fimg.sccnn.com%2Fbimg%2F338%2F38039.jpg&refer=http%3A%2F%2Fimg.sccnn.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=jpeg?sec=1614496892&t=7c73193bffc2e3d431b6ec13e82b487c";
            return{
                user
            }
        }
    }
</script>

<style scoped>
    .flex_l{display: flex;flex-direction: row;align-items: center;flex-wrap: wrap;justify-content:flex-start;}

    .bannerBox {
        width: 100%;
        height: 100px;
        position: relative;
        text-align: center;
        overflow: hidden;
    }
    .bannerBg {
        width: 1040px;
        height: 91px;
        margin: 0 auto;
        background: url("../assets/image/titlebg.png") no-repeat;
        background-size: 100% 100%;
        position: absolute;
        margin-left: calc((100% - 1040px)/2);
    }
    .topTitle{
        font-size: 40px;
        color: #01EEDE;
        margin-top: 12px;
        font-weight: bold;
    }
    .leftLogo{
        width: 600px;
        height: 60px;
        position: absolute;
        left: 0;
        top: 18px;
        color: white;
        font-size: 30px;
    }
    .leftLogo img {
        width: 60px;
        height: 60px;
        border-radius: 50%;
        margin-right: 12px;
    }
    .leftLogo span
    {
        line-height: 60px;
        font-weight: bold;
    }
    @media screen and (max-width: 600px) {
        .leftLogo{
            opacity: 0;
        }
        .bannerBg {
            opacity: 0;
        }
        .topTitle{
            font-size: 30px;
            margin-top: 22px;
        }
    }
</style>
